<template>
  <div id="home" >
    <!-- 首页 -->
    <tabulate />

    <div class="buy-record">
      操作记录
    </div>

<!--    <search @onSearch="onSearch" placeholder="请输入用户名搜索" />-->
    <div class="margin-top-30">
      <a-table bordered
               :columns="columns"
               :data-source="logHistoryData"
               :loading="loading"
               :pagination="pagination"
               @change="handleTableChange"
               >
      </a-table>
    </div>
  </div>
</template>

<script>
const columns = [
  {title: "请求平台", dataIndex: 'loginFacility', align: "center",width: 120},
  {title: '请求地址', dataIndex: 'requestUrl', align: "center",ellipsis: true},
  {title: '请求方式', dataIndex: 'requestWay', align: "center",width: 100},
  {title: '请求参数', dataIndex: 'requestParam', align: "center",ellipsis: true},
  {title: '返回参数', dataIndex: 'returnParam', align: "center",ellipsis: true},
  {title: '耗时', dataIndex: 'time', align: "center",width: 100},
  {title: '请求时间', dataIndex: 'createDate', align: "center",ellipsis: true},
  {title: '操作人', dataIndex: 'operatorId', align: "center",width: 100}
]

import Search from 'components/content/search/Search.vue';
import tabulate from './childComps/Tabulate';
import { LogHistory } from 'api/home'

export default {
  name: 'home',
  components: {
    tabulate,
    Search,
  },
  data() {
    return {
      columns,
      pagination: {
				defaultPageSize: 10,
        showQuickJumper: true,
        total: 0,
        showTotal: total => `共 ${this.pagination.total} 条数据`,
        onShowSizeChange: (current, pageSize) => this.pageSize = pageSize
      },

      loading: false,
      visible: false,

      searchText: "",

      page: 0,
      pageSize: 10,
      userName: "",
      logHistoryData: [],

      /*-------------- */
      refun: {
        deviceType: "",
        deviceNumber: 0,
        businessId: "",
        fee: 0,
        rebate: "",
        remark: ""
      }
    }
  },
  mounted() {
    this.getLogHistory(this.page, this.pageSize, this.userName)
  },
  methods: {
    /**
     * 逻辑区
     */
    // 搜索
    onSearch(value) {
      this.userName = value;
      this.getLogHistory(this.page, this.pageSize, this.userName)
    },
    // 表格页面跳转
    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.page = pagination.current
      this.getLogHistory(this.page, this.pageSize, this.userName)
    },
    /********************************************** */
    // 取消
    handleCancel() {
      this.retainage = "",
      this.remark = "",
      this.visible = !this.visible
    },
    /**
     * 接口区
     */
    // 购买记录
    getLogHistory(page, pageSize, userName) {
      this.loading = true
      LogHistory(page, pageSize, userName)
        .then(res => {
          if(res.data.rows.length > 0) {
            const data = res.data.rows;
            this.pagination.total = res.data.total;
            this.logHistoryData = data;
          } else {
            this.$message.error('没有查询到结果，请重试！');
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          console.log(err)
        })
    }
  }
}
</script>

<style lang='scss' scoped>
  .buy-record {
    width: 144px;
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #131212;
    line-height: 80px;
  }
  /**** */
  .refundTitle {
    line-height: 50px;
    font-size: 32px;
    font-weight: 500;
    text-align: center;
    color: #131212;
    margin-bottom: 20px;
  }
  .refundItem {
    line-height: 36px;
    font-size: 24px;
    color: #131212;
    .input-wrap {
      display: inline-block;
      width: 90px;
    }
    .textarea-wrap {
      display: inline-block;
      width: 500px;
      vertical-align: top;
    }
  }
  .btn-wrap {
    text-align: center;
    padding: 20px 0;
  }
</style>
